import { Pipe, PipeTransform } from '@angular/core';
import { CanalCommunication } from '../../models/canalCommunication';

@Pipe({
	name: 'filterCanalCommunicationByName'
})
export class FilterCanalCommunicationByNamePipe implements PipeTransform {
	transform(canalCommunication: CanalCommunication[], filter: string): CanalCommunication[] {
		if (
			!canalCommunication ||
			!filter ||
			canalCommunication === null ||
			filter === null ||
			filter === ''
		) {
			return canalCommunication;
		}

		return canalCommunication.filter((canalCommunication: CanalCommunication) => {
			if (canalCommunication.name) {
				// TODO: add lastName too
				return canalCommunication.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
